import { SearchEmbed } from '@thoughtspot/visual-embed-sdk/lib/src/react'

import PageContainer from 'common/components/PageContainer'

import { EMBED_CLASS_NAME } from './styles'

export const DataSearch = () => {
  return (
    <PageContainer>
      <SearchEmbed dataPanelV2 className={EMBED_CLASS_NAME} />
    </PageContainer>
  )
}
